import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import CardContent from "@origyn-sa/common-ui/src/components/atoms/CardContent";
import { H2, H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import { useAppDispatch } from "@origyn-sa/common-ui/src/components/../store/store";
import Text from "@origyn-sa/common-ui/src/components/atoms/Text";
import HR from "@origyn-sa/common-ui/src/components/atoms/HR/HR.styled";
import Select from "@origyn-sa/common-ui/src/components/molecules/Select";
import Label from "@origyn-sa/common-ui/src/components/atoms/Label";
import { PaymentMethodType } from "../../types";
import { LinearProgress } from "@material-ui/core";
import { Principal } from "@dfinity/agent";

export interface IListItemModal {
  open: boolean;
  onClose?: () => void;
  onList: (val: any) => void;
  paymentMethods: PaymentMethodType[];
  collections: {
    symbol: string;
    _principal: Principal;
    fee: { fee: Number; feeRecipient: Principal };
  }[];
}

const schema = yup.object({
  // FIXME: validation
  // tokenId: yup.string().required(),
  // paymentMethod: yup.string().required(),
  // listingPrice: yup.number().required(),
});

const ListItemModal = ({
  open,
  onClose,
  onList,
  collections,
  paymentMethods = [],
}: IListItemModal): JSX.Element => {
  const [loader, setLoader] = useState<boolean>(false);
  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: any) => {
    setLoader(true);
    console.log("onSubmit", data);
    if (onList) onList(data);
    // setTimeout(() => setLoader(false), 5000);
  };

  const collectionsOpts = collections.map((val: any) => ({
    label: `${val.symbol} (${val._principal.toText()})`,
    value: val._principal.toText(),
  }));
  const pmValue = watch("paymentMethod");
  const listingPrice = watch("listingPrice");
  const collectionV = watch("collection");
  const tokenId = watch("tokenId");
  useEffect(() => {
    setValue("collection", collections[0]);
  }, []);

  const selectedPm = paymentMethods.find((pm) => pm._principal === pmValue);
  console.log({ pmValue, selectedPm });

  console.log({
    collectionV,
    selectedPm,
    listingPrice,
    tokenId,
  });
  return (
    <Dialog open={open} onClose={onClose}>
      {loader && <LinearProgress style={{ top: 0, left: 0, width: "200%" }} />}
      <CardContent textAlign='center' padding='40px 55px'>
        <Grid container justify='center' spacing={1}>
          <Grid item>
            <H3 spacing={[0, 3]}>List</H3>
          </Grid>
        </Grid>
        <Form onSubmit={handleSubmit(onSubmit)} schema={schema}>
          <Grid item xs={12}>
            <Label>Collection</Label>
            <Select
              small={false}
              // isDisabled
              defaultValue={undefined}
              // onChange={()}
              name='collection'
              onChange={(val: any) => {
                console.debug({ val });
                const col = collections.find(
                  (c) => c._principal.toText() === val.value
                );
                if (col) setValue("collection", col);
              }}
              options={collectionsOpts}
            />
            <Text>
              <i>
                Each trade for that collection takes{" "}
                {(Number(collections[0]?.fee?.fee) / 100).toFixed(2)} % and is
                rewarded to {collections[0]?.fee?.feeRecipient.toText()}
              </i>
            </Text>
            <InputField
              required
              error={errors.tokenId}
              label='Token ID'
              name='tokenId'
              onChange={(val: any) => {
                console.debug({ val });
                setValue("tokenId", val?.target?.value);
              }}
              defaultValue={""}
            />
            <Label>Payment method</Label>
            <Select
              small={false}
              onChange={(val: any) => {
                console.debug({ val });
                if (val && (val as any).value)
                  setValue("paymentMethod", (val as any).value);
              }}
              placeholder='Choose payment method'
              options={paymentMethods.map((pm) => ({
                value: pm._principal,
                label: `${pm.name} (${pm._principal})`,
              }))}
            />
            <br />
            <InputField
              required
              error={errors.listingPrice}
              label='Price'
              name='listingPrice'
              disabled={!pmValue}
              onChange={(val: any) => {
                setValue("listingPrice", val?.target?.value);
              }}
              inputProps={{
                step: String(
                  Number(1 / 10 ** Number(selectedPm?.decimal || 0))
                ),
              }}
              placeholder='Listing Price'
              type='number'
            />
            {/* <InputField
              required
              label='Recipient ICP Account Identifier'
              name='recipientIdentifier'
              disabled={!pmValue}
              onChange={(val: any) => {
                setValue("recipientIdentifier", val?.target?.value);
              }}
              placeholder='ICP Account Identifier (aaaaaa...)'
              type='text'
            /> */}

            {/* recipient_identifier */}
            <HR />
            <Grid item>
              {/* <Grid item>
                  <Label>Collection name</Label>
                  <Label>{item.canisterID}</Label>
                </Grid>
                <br />
                <Label>NFT Principal</Label>
                <br />

                <Label>Platform fee</Label>
                <br />

                <Label>Fee from the item</Label>
                <br /> */}

              <Label>
                Listing Price: {listingPrice} {selectedPm?.name}
              </Label>
            </Grid>
          </Grid>

          <Button
            disabled={
              loader ||
              !(collectionV && selectedPm && listingPrice > 0.0 && tokenId)
            }
            type='submit'
            spacing={2}
          >
            Confirm Listing
          </Button>
        </Form>
      </CardContent>
    </Dialog>
  );
};

export default ListItemModal;
